export default __webpack_public_path__ + "static/PROUD_3xl-91e06118328995483827cf72dbe80e95.webp";